import * as React from "react";
import { DialogTitle, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useDetachFromGroup } from "@/hooks/api/use-contacts";
import { FilterFetchSelect } from "@/components/fetch-select";
import { FilterOption, Option } from "@/components/customTable/types";


export interface DetachFromGroupProps {
	open: boolean;
	onClose: () => void;
	rows: any[];
}

export function DetachFromGroup({
	open,
	onClose,
  rows,
}: DetachFromGroupProps): React.JSX.Element {
  const [group, setGroup] = React.useState<Option>({ label: "", value: "" });

  const detachFromGroupMutation = useDetachFromGroup();

  const handleSubmit = async () => {
    await detachFromGroupMutation.mutateAsync({
      groupId: group?.value as string,
      contactIds: rows,
    });
    
    onClose();

    setTimeout(() => {
      setGroup({ label: "", value: "" });
    }, 300);
  }
	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle sx={{ p: 3, pb: 2 }}>
				<Stack direction="row" spacing={2} sx={{ display: "flex" }}>
					<Stack spacing={3}>
						<Stack spacing={1}>
							<Typography variant="h5">Detach from Group</Typography>
							<Typography color="text.secondary" variant="body2">
								Please select a group to detach the selected contacts from.
							</Typography>
						</Stack>
					</Stack>
				</Stack>
			</DialogTitle>
			<DialogContent sx={{ px: 3 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 12 }}>
            <FilterFetchSelect
              label="Group"
              showInputLabel
              placeholder="Select a group"
              onChange={(value: FilterOption | string) => {
                setGroup(value as Option);
              }}
              getOptionsUrl="/crm/groups?isStatic=true"
              fetchLabel="name"
              fetchValue="id"
              value={{ label: group.label, value: group.value } as FilterOption}
            />
          </Grid>
        </Grid>
				
			</DialogContent>
			<DialogActions sx={{ p: 3, py: 2 }}>
				<Stack direction="row" spacing={2} sx={{ justifyContent: "flex-end" }}>
					<Button color="secondary" onClick={onClose}>
						Cancel
					</Button>
					<Button
						variant="contained"
						onClick={handleSubmit}
						disabled={detachFromGroupMutation.isPending || !group.value}
					>
						Confirm
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
}
